module.exports = __webpack_public_path__ + "img/10-stylists-laserbeamer.png";